import { useSelector } from 'react-redux';
import { Text } from '@/vdp/EarliestDelivery/PickupAndDelivery/PickupAndDelivery.styles';
import ShippingTooltip from '@/vdp/EarliestDelivery/PickupAndDelivery/ShippingTooltip';
import TransitChargeState from '~/constants/TransitChargeState';
import ShippingCostIcon from '~/icons/ShippingCost';
import { getTransitChargeInfo } from '~/selectors';
import formatAndDropDecimal from '~/utilities/formatAndDropDecimal';

type OwnProps = {
  hasCars?: boolean;
};
const Shipping = ({ hasCars = false }: OwnProps) => {
  const transitCharge = useSelector(getTransitChargeInfo);

  const hasTransitCharge = transitCharge.state === TransitChargeState.HasCharge;

  if (hasTransitCharge)
    return (
      <Text
        className="mt-24 flex items-center justify-center text-center"
        data-qa="shipping"
      >
        <ShippingCostIcon className="mr-4" />$
        {formatAndDropDecimal(transitCharge.data)} Shipping
        <ShippingTooltip
          transitCharge={formatAndDropDecimal(transitCharge.data)}
        />
      </Text>
    );

  return hasCars ? <div className="my-12 h-16 m:hidden" /> : null;
};

export default Shipping;
